module.exports = __webpack_public_path__ + "static/media/rachit.863e68b1.jpeg";